import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { LandingPageData } from "@/types/landing.types";
import { createAsyncThunk } from "@reduxjs/toolkit";

export async function fetchLandingPageByUrl(
  url: string,
): Promise<LandingPageData | null> {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3500);

    const res = await fetch(
      `${API_PORTAL_URL}/PageSlidingEvent/FindByURLPageSlidingEvent`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ URL: url }),
        // next: { revalidate: 30 },
        signal: controller.signal,
      },
    );

    clearTimeout(timeoutId);

    if (res.ok) {
      const json = await res.json();
      if (json?.Data && json?.Data?.IsActive !== false) {
        return json.Data;
      }
    }
  } catch (err) {
    console.warn(
      "fetchLandingPageByUrl network request failed or timed out:",
      err,
    );
  }

  return null;
}

export async function fetchLandingPage() {
  try {
    const res = await fetch(
      `${API_PORTAL_URL}/PageSlidingEvent/FindAllActivePageSlidingEvent`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        next: { revalidate: 30 },
      },
    );
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}

export const getAllActiveLandingPages = createAsyncThunk(
  "PageSlidingEvent/FindAllActivePageSlidingEvent",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/PageSlidingEvent/FindAllActivePageSlidingEvent`,
      );
      return response.data?.Data || [];
    } catch (error: any) {
      const err = error as { response?: { data?: { Details?: string } } };
      console.error("Error Fetching Events:", error);
      return Promise.reject({
        message: err?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
